'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')
let DeviceTypes = require('src/common/app-constants').deviceTypes

/* Views */
var View = require('./view.js')

var DeviceSituationShow = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      var self = this

      var device = options.device


      // asset data
      let deviceTypeDef = DeviceTypes.find(def => def.id === device.get('type'))

      var AssetDataModel = Backbone.Model.extend({
        urlRoot: App.config.externalData.assetDataUrl + device.get('_id')
      });

      var assetData

      if (deviceTypeDef.hasAssetData) {
        assetData = new AssetDataModel()
      }

      this.layout = self.getLayoutView(device, assetData)
      
      this.listenTo(assetData, 'change',  function(model){
        self.layout.render();
      });

      if (deviceTypeDef.hasAssetData) {
        assetData.set([
          {
            "key": "veld_1",
            "value":"waarde 1"
          },
          {
            "key": "veld_2",
            "value":"waarde 2"
          },
          {
            "key": "veld_3",
            "value":"waarde 3"
          }
        ]);
        assetData.fetch();
      }

      options.region.show(this.layout)
    },
    /* Event methods --------------------------------------------------------- */
    /* Regions --------------------------------------------------------------- */
    /* Views ----------------------------------------------------------------- */
    getLayoutView: function (device, assetData) {
      return new View.Layout({model: device, assetData: assetData})
    }
  })

  return new Controller(options)
}

module.exports = DeviceSituationShow



// WEBPACK FOOTER //
// ./js/modules/device-situation/show/index.js